import { ECompetitorsLevel, ICompetitorService } from '../../../../../../../../reducers/v2';
import { EServiceId } from '../../../../../../../../types/reducers/publishTerms';
import { ICompetitorServiceIU } from '../types';
import { mapCompetitorTypeToTitle } from './mapCompetitorTypeToTitle';
import { isCompetitorSelected } from './isCompetitorSelected';

export const mapCompetitorsToPromotionsList = (
  competitors: ICompetitorService[],
  selectedService: EServiceId | null,
  isBetMoreThanTop: boolean,
): (ICompetitorServiceIU & { level: ECompetitorsLevel })[] =>
  competitors.map(({ amount, promotionType, competitionLevel }) => ({
    amount,
    title: mapCompetitorTypeToTitle(promotionType),
    selected: isCompetitorSelected(selectedService, promotionType, isBetMoreThanTop),
    level: competitionLevel,
  }));
